import { cr } from "fire-wind-water";

class Tips {
  private elem: HTMLElement;
  private child: HTMLElement;
  protected isShow = false;
  protected recursionList: any[] = [];

  static createElem(c: string, h?: string): HTMLElement {
    const elem = document.createElement("div");
    elem.className = c;
    if (h) {
      elem.innerHTML = h;
    }
    return elem;
  }

  static create(t: any, h?: string): void {
    t.elem = Tips.createElem("sk-weak-hint");
    t.child = Tips.createElem("weak-hint-wrap tips-hide", h);
    t.elem.appendChild(t.child);
    document.body.appendChild(t.elem);
  }

  static recursion(t): void {
    if (t.isShow) {
      return;
    }
    const o = t.recursionList.shift();
    if (o) {
      Tips.showAlert(t, o[0], o[1]);
    }
  }

  static showAlert(t, s, c): void {
    t.isShow = true;
    Tips.create(t, s);
    setTimeout(() => {
      t.child.className = "weak-hint-wrap";
    }, 10);
    setTimeout(() => {
      t.hide(c.callback);
    }, c.time + 400);
  }

  show(s: string, c: any = { time: 300 }): void {
    this.recursionList.push([s, c]);
    Tips.recursion(this);
  }

  close(): void {
    this.recursionList = [];
  }

  hide(c: any): void {
    this.child.className = "weak-hint-wrap tips-hide";
    setTimeout(() => {
      document.body.removeChild(this.elem);
      this.isShow = false;
      if (cr.isFunction(c)) {
        c();
      }
      if (this.recursionList.length > 0) {
        Tips.recursion(this);
      }
    }, 400);
  }
}

const sktips = new Tips();

export { sktips };
